// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"n5-z"};